export const CONTENT_TYPES = {
  product: 'product',
  productFinder: 'product_finder',
  retailer: 'retailer',
  wholeseller: 'wholeseller',
  customer: 'customer',
}

export const CHAT_CONTEXT_TYPES = {
  product: 'Product',
  productFinder: 'Finder',
  bidding: 'Bidding',
  retailer: 'Retailer',
}
